module.exports = __webpack_public_path__ + "media/images/talent/lp/case04-1dd91f0269cb61cdd85fe9e5aceb4390.png";